import React from 'react'
import styled from 'styled-components'
import { BallTriangle } from 'react-loader-spinner'

const Spinner = () => {
  return (
    <Container className='loadingSpinnerContainer'>
        <SpinnerContainer className='loadingSpinner'>
          <BallTriangle
            height={100}
            width={100}
            radius={5}
            color="#4fa94d"
            ariaLabel="ball-triangle-loading"
            wrapperClass={{}}
            wrapperStyle=""
            visible={true}
          /> 
          <h4>Loading...</h4>
        </SpinnerContainer>
    </Container>
  )
}

const Container = styled.section`
  position: relative;

`

const SpinnerContainer = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -50%;
  left: 50%;

  & > h4{
    color: #4fa94d;
  }

`

export default Spinner